import { isDirectSendGatedToolName } from './directSendTools';

// Tools that create persistent workspace state. A direct model call to one is
// refused unless the call arrives through propose_actions, or the run is
// non-interactive and the tool is pre-approved. Kept apart from
// DIRECT_SEND_GATED_TOOL_NAMES: these do not send anything outside the workspace.
export const DIRECT_WRITE_GATED_TOOL_NAMES = [
  'propose_flow',
  'propose_custom_agent',
  'create_task_group',
  'create_person',
  'create_person_event',
  'execute_create_knowledge_page',
  'execute_edit_knowledge_page',
] as const;

export type DirectWriteGatedToolName =
  (typeof DIRECT_WRITE_GATED_TOOL_NAMES)[number];

const DIRECT_WRITE_GATED_TOOL_NAME_SET: ReadonlySet<string> = new Set(
  DIRECT_WRITE_GATED_TOOL_NAMES,
);

export const isDirectWriteGatedToolName = (
  name: unknown,
): name is DirectWriteGatedToolName =>
  typeof name === 'string' && DIRECT_WRITE_GATED_TOOL_NAME_SET.has(name);

// Create automations that run later without a human. Never pre-approvable: an
// unattended run could otherwise mint new unattended runs.
export const NEVER_PRE_APPROVED_TOOL_NAMES = [
  'propose_flow',
  'propose_custom_agent',
] as const;

export type NeverPreApprovedToolName =
  (typeof NEVER_PRE_APPROVED_TOOL_NAMES)[number];

export const NEVER_PRE_APPROVED_TOOL_NAME_SET: ReadonlySet<string> = new Set(
  NEVER_PRE_APPROVED_TOOL_NAMES,
);

export const isNeverPreApprovedToolName = (
  name: unknown,
): name is NeverPreApprovedToolName =>
  typeof name === 'string' && NEVER_PRE_APPROVED_TOOL_NAME_SET.has(name);

export const PRE_APPROVABLE_DIRECT_WRITE_TOOL_NAMES =
  DIRECT_WRITE_GATED_TOOL_NAMES.filter(
    (name) => !isNeverPreApprovedToolName(name),
  );

export const isInteractivePreApprovableToolName = (
  name: unknown,
): name is string =>
  typeof name === 'string' &&
  !isDirectSendGatedToolName(name) &&
  !isNeverPreApprovedToolName(name);
